var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGemini(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.05 32.877V7.075C24.53 6.038 28.348 3.443 30.753 0c-.755 0-1.603 0-2.546.047-2.876 3.444-7.497 5.708-12.73 5.708-5.187 0-9.807-2.217-12.683-5.66H.248c2.357 3.396 6.129 5.943 10.56 6.98v25.85c-4.431 1.084-8.203 3.632-10.56 6.98h2.546c2.876-3.443 7.496-5.66 12.683-5.66 5.186 0 9.854 2.264 12.73 5.708.895 0 1.744 0 2.546.047-2.405-3.49-6.224-6.038-10.703-7.123zm-7.402-.283V7.453a18.59 18.59 0 0 0 2.829.189c.942 0 1.838-.048 2.734-.19v25.095c-.896-.141-1.791-.188-2.734-.188-.943 0-1.886.094-2.83.235z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemini);
export default __webpack_public_path__ + "static/media/gemini.f21f74d9bcfcb5ff8efc317e92274adc.svg";
export { ForwardRef as ReactComponent };